// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"af58e159","230":"da4dbfcc","515":"41e0c427","673":"d233609b"}[chunkId] + ".chunk.js";
};